import React, { useEffect, useState } from 'react'

import TagCloud from 'TagCloud'

const WordCloud = () => {
  const [isLoading, setLoad] = useState(true)

  const container = '.content'
  const texts = [
    'Java',
    'Spring Boot',
    'Spring AI',
    'Angular',
    'Microservices',
    'Vue.js',
    'Nuxt.js',
    'TypeScript',
    'Langchain',
    'CrewAI',
    'AI',
    'MySQL',
    'Oracle',
    'Git',
    'Docker',
    'Tech Lead',
  ]
  const options = {
    radius: 300,
    // animation speed
    // slow, normal, fast
    maxSpeed: 'fast',
    initSpeed: 'fast',
    // 0 = top
    // 90 = left
    // 135 = right-bottom
    direction: 135,
    // interact with cursor move on mouse out
    keep: true,
  }
  //   to render wordcloud each time the page is reloaded
  useEffect(() => {
    if (isLoading) {
      // Clear any existing word cloud
      const element = document.querySelector(container)
      if (element) {
        element.innerHTML = ''
      }
      TagCloud(container, texts, options)
      setLoad(false)
    }
  }, [isLoading])

  return (
    <div className="main">
      <span className="content"></span>
    </div>
  )
}

export default WordCloud
